import { SUPPORT_EMAIL } from './config';

export function buildContactMailto(description: string, email: string) {
  const subject = 'DesignForge — ý kiến hoặc yêu cầu';
  const body = [
    'Xin chào DesignForge,',
    '',
    'Tôi muốn gửi ý kiến / yêu cầu sau:',
    description.trim(),
    '',
    `Email để liên hệ lại: ${email.trim()}`,
  ].join('\n');
  return `mailto:${SUPPORT_EMAIL}?${new URLSearchParams({ subject, body }).toString()}`;
}
